// Highlight rolloff: soft-knee compression of HDR scene color before bloom.
// Prevents additive enemy/flash stacks from clipping to a flat white blob.

import * as THREE from 'three';

export const HighlightRolloffShader = {
  uniforms: {
    tDiffuse: { value: null as THREE.Texture | null },
    // Compression strength; higher = more aggressive highlight rolloff.
    knee: { value: 0.65 }
  },

  vertexShader: /* glsl */ `
    varying vec2 vUv;

    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,

  fragmentShader: /* glsl */ `
    uniform sampler2D tDiffuse;
    uniform float knee;
    varying vec2 vUv;

    void main() {
      vec3 col = texture2D(tDiffuse, vUv).rgb;
      // Hue-preserving hard luminance target: stacked additive highlights are
      // compressed to a max of 0.85 so they shade to saturated color instead of
      // clipping to white. A soft shoulder avoids banding.
      float m = max(col.r, max(col.g, col.b));
      float target = 0.85;
      float shoulder = 0.15;
      float scale = 1.0;
      if (m > target) {
        scale = target / m;
      } else if (m > target - shoulder) {
        float t = (m - (target - shoulder)) / shoulder;
        scale = mix(1.0, target / m, t * t);
      }
      col *= scale;
      gl_FragColor = vec4(col, 1.0);
    }
  `
};
